import React from 'react';

class Footer extends React.Component {
    render(){
        return (
            <div className="footer">
                <p><a href="https://wwnorton.com/terms-of-use" target="_blank">Terms of Use</a> | <a href="https://wwnorton.com/privacy-policy" target="_blank">Privacy Policy</a></p>
            </div>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js